import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { GlobalErrorHandlerService } from '@vmspdb/ui/common';
import { AuthRunEffects } from '@vmspdb/ui/store';
import { concatMap } from 'rxjs/operators';
import { SurveyTaskRepositoryService } from '../../repositories';
import * as SurveyTasksActions from './survey-tasks.actions';

@Injectable()
export class SurveyTasksEffects extends AuthRunEffects {
  private repository = inject(SurveyTaskRepositoryService);
  private errors = inject(GlobalErrorHandlerService);

  deleteSurveyTask$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(SurveyTasksActions.deleteSurveyTask),
        concatMap(({ id }) => this.repository.delete(id)),
      );
    },
    { dispatch: false },
  );

  constructor() {
    const actions$ = inject(Actions);

    super(actions$);
  }
}
